import { ChangeDetectionStrategy, Component, ViewEncapsulation, signal } from "@angular/core";
import { LANDING_TREESLO_DASHBOARD_URL } from "../../shared/landing-app-url.constant";
import { Landing1NavbarComponent } from "./sections/landing-1-navbar/landing-1-navbar.component";
import { Landing1HeroComponent } from "./sections/landing-1-hero/landing-1-hero.component";
import { Landing1OurProductComponent } from "./sections/landing-1-our-product/landing-1-our-product.component";
import { Landing1RecoveryStatementComponent } from "./sections/landing-1-recovery-statement/landing-1-recovery-statement.component";
import { Landing1FeaturesComponent } from "./sections/landing-1-features/landing-1-features.component";
import { Landing1HowItWorksComponent } from "./sections/landing-1-how-it-works/landing-1-how-it-works.component";
import { Landing1OnboardingComponent } from "./sections/landing-1-onboarding/landing-1-onboarding.component";
import { Landing1WhyComponent } from "./sections/landing-1-why/landing-1-why.component";
import { Landing1CompareComponent } from "./sections/landing-1-compare/landing-1-compare.component";
import { Landing1PricingComponent } from "./sections/landing-1-pricing/landing-1-pricing.component";
import { Landing1CtaComponent } from "./sections/landing-1-cta/landing-1-cta.component";
import { Landing1FooterComponent } from "./sections/landing-1-footer/landing-1-footer.component";
import { Landing1ScrollTopComponent } from "./sections/landing-1-scroll-top/landing-1-scroll-top.component";

@Component({
  selector: "app-landing-1",
  standalone: true,
  imports: [
    Landing1NavbarComponent,
    Landing1HeroComponent,
    Landing1OurProductComponent,
    Landing1RecoveryStatementComponent,
    Landing1FeaturesComponent,
    Landing1HowItWorksComponent,
    Landing1OnboardingComponent,
    Landing1WhyComponent,
    Landing1CompareComponent,
    Landing1PricingComponent,
    Landing1CtaComponent,
    Landing1FooterComponent,
    Landing1ScrollTopComponent,
  ],
  templateUrl: "./landing-1.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class Landing1Component {
  /** External app entry — landing is auth-agnostic; app handles login. */
  readonly treesloDashboardUrl = LANDING_TREESLO_DASHBOARD_URL;

  readonly showScrollTop = signal(false);

  onHeroScrollTopVisibleChange(visible: boolean): void {
    this.showScrollTop.set(visible);
  }

  scrollToTop(): void {
    const behavior: ScrollBehavior = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches
      ? "auto"
      : "smooth";

    (document.scrollingElement ?? document.documentElement).scrollTo({
      top: 0,
      behavior,
    });
  }
}
